export default [{
    title: 'mainmenu.employee-benefit.title',
    icon: {
        icon: 'ri-settings-4-line'
    },
    children: [{
        title: 'mainmenu.employee-benefit.overview',
        feature: 'view_claim_plan',
        to: {
            path: '/employee-benefit/overview'
        },
        icon: {
        icon: 'ri-settings-4-line'
        }
    },{
        title: 'mainmenu.employee-benefit.coin-management',
        feature: 'view_benefit_distribute_schedule',
        to: {
            path: '/employee-benefit/coin-management'
        },
        icon: {
            icon: 'ri-group-line'
        }
    },{
        title: 'mainmenu.employee-benefit.reports',
        feature: 'view_usage_reports',
        to: {
            path: '/employee-benefit/reports'
        },
        icon: {
            icon: 'ri-link'
        }
    },{
        title: 'mainmenu.employee-benefit.claim-management',
        feature: 'view_claim_report',
        to: {
            path: '/employee-benefit/claim-management'
        },
        icon: {
            icon: 'ri-thumb-up-line'
        }
    },{
        title: 'mainmenu.employee-benefit.admin-claim',
        feature: 'create_claim_report',
        to: {
            path: '/employee-benefit/claim-management/admin-submit-claim'
        },
        icon: {
            icon: 'ri-thumb-up-line'
        }
    }]
},{
    title: 'mainmenu.company-setting.title',
    icon: {
        icon: 'ri-settings-4-line'
    },
    children: [{
        title: 'mainmenu.company-setting.profile',
        feature: 'view_distributor_settings',
        to: {
            path: '/company-setting/profile'
        },
        icon: {
            icon: 'ri-settings-4-line'
        }
    }, {
        title: 'mainmenu.company-setting.employee',
        feature: 'view_employee',
        to: {
            path: '/company-setting/employee'
        },
        icon: {
            icon: 'ri-group-line'
        }
    },{
        title: 'mainmenu.company-setting.team',
        feature: 'view_team',
        to: {
            path: '/company-setting/team'
        },
        icon: {
            icon: 'ri-group-line'
        }
    },{
        title: 'mainmenu.company-setting.billing',
        feature: 'view_usage_reports_temp',
        to: {
            path: '/company-setting/billing'
        },
        icon: {
            icon: 'ri-settings-4-line'
        }
    },{
        title: 'mainmenu.company-setting.medical-cards',
        feature: 'enable_medical',
        to: {
            path: '/company-setting/medical-cards'
        },
        icon: {
            icon: 'ri-stethoscope-line'
        }
    }]
}]